//申诉详情页进度详情节点维护
import submit from '../../static/actionPic/submit.png';//提交icon
import submitRed from '../../static/actionPic/submit_red.png';
import supplement from '../../static/actionPic/supplement.png';//补充资料icon
import supplementRed from '../../static/actionPic/supplement_red.png';
import audit from '../../static/actionPic/audit.png';//审核icon
import auditRed from '../../static/actionPic/audit_red.png';
import submitSuc from '../../static/actionPic/submit_suc.png';//提交成功icon
import submitSucRed from '../../static/actionPic/submit_suc_red.png';
import proof from '../../static/actionPic/proof.png';//补充凭证icon
import proofRed from '../../static/actionPic/audit_red.png';

export interface progressType {
    actionCode: number,//节点状态
    actionCodeName: string,//节点名称
    actionCodeTalkingSkill?: string,//节点话术
    actionCodeIcon: string,//提交灰色icon
    actionCodeRedIcon: string,//提交红色icon
    actionSucName?: string,//提交成功节点名称
    actionSuc?: string,//提交成功节点话术
    actionSucTalkingSkill?: string,//提交成功节点话术
    actionSucOperator?: string,//操作人
    actionSucIcon?: string,//提交成功灰色icon
    actionSucRedIcon?: string,//提交成功红色icon
    operators?: string,//操作人
    actionType?: number;
}
//提交申诉成功和二次申诉提交成功后端没有节点，时间使用提交时的时间
export const progress = [
    {
        actionCode: 1,//节点状态
        actionCodeName: '提交申诉',//节点名称
        actionCodeTalkingSkill: '申诉理由: ',//节点话术
        actionCodeIcon: submit,//提交灰色icon
        actionCodeRedIcon: submitRed,//提交红色icon
        actionSucName: '申诉单提交成功',//提交成功节点名称
        actionSuc: '已创建申诉单号: ',//提交成功节点话术
        actionSucTalkingSkill: '预计1-3天审核完成',//提交成功节点话术
        actionSucOperator: '经办人: 申诉处理部',//操作人
        actionSucIcon: submitSuc,//提交成功灰色icon
        actionSucRedIcon: submitSucRed,//提交成功红色icon
    },
    {
        actionCode: 2,
        actionCodeName: '申诉撤销',
        operators: '经办人: 用户',
        actionCodeTalkingSkill: ' ',
        actionCodeIcon: supplement,
        actionCodeRedIcon: supplementRed,
    },
    {
        actionCode: 3,
        actionCodeName: '补充材料提醒',
        actionCodeTalkingSkill: ' ',
        operators: '经办人: 申诉处理部',
        actionCodeIcon: supplement,
        actionCodeRedIcon: supplementRed,
    },
    {
        actionCode: 4,
        actionCodeName: '补充凭证',
        actionCodeTalkingSkill: ' ',
        operators: '经办人: 用户',
        actionCodeIcon: proof,
        actionCodeRedIcon: proofRed,
    },
    {
        actionCode: 5,
        actionCodeName: '未在规定时间内补充材料',
        actionCodeTalkingSkill: '请在24小时内完成申诉材料补充，逾期未提交，系统将提交审核',
        operators: '经办人: 申诉处理部',
        actionCodeIcon: supplement,
        actionCodeRedIcon: supplementRed,
    },
    {
        actionCode: 6,
        actionCodeName: '审核未通过',
        actionCodeTalkingSkill: '未通过原因: ',
        operators: '经办人: 申诉处理部',
        actionCodeIcon: audit,
        actionCodeRedIcon: auditRed,
    },
    {
        actionCode: 7,
        actionCodeName: '审核已通过',
        actionCodeTalkingSkill: '审核说明: ',
        operators: '经办人: 申诉处理部',
        actionCodeIcon: audit,
        actionCodeRedIcon: auditRed,
    },
    {
        actionCode: 8,
        actionCodeName: '二次提交申诉',
        actionCodeTalkingSkill: '申诉理由: ',
        actionCodeIcon: submit,
        actionCodeRedIcon: submitRed,
        actionSucName: '申诉单提交成功',
        actionSuc: '二次申诉问题重新分配至上一办结人',
        actionSucTalkingSkill: '预计1-3天审核完成',
        actionSucOperator: '经办人: 申诉处理部',
        actionSucIcon: submitSuc,
        actionSucRedIcon: submitSucRed,
    },
    {
        actionCode: 9,
        actionCodeName: '补充凭证',
        operators: '经办人: 平台客服',
        actionCodeIcon: proof,
        actionCodeRedIcon: proofRed,
    },
    {
        actionCode: 10,
        actionCodeName: '审核回复',
        operators: '经办人: 申诉处理部',
        actionCodeTalkingSkill: ' ',
        actionCodeIcon: audit,
        actionCodeRedIcon: auditRed,
    },
];